<div class="padding-inputs">
    <div>
        <div class="section-input">
            <div class="d-flex align-items-center justify-content-between input-border">
                <div class="select-style calendar-date" [class.pointer-in]="!notEditable" [class.active]="typeDatepicker == 'start'"
                    (click)="openDatePicker('start')">
                    <i class="fa-light fa-calendar"></i>
                    <input [placeholder]="placeholder" class="input-date" [class.pointer-in]="!notEditable" readonly
                        [(ngModel)]="startStringDate" [ngModelOptions]="{standalone: true}">
                    <i class="icon-down fa-light fa-chevron-down"></i>
                </div>
            </div>

            <div class="d-flex align-items-center justify-content-center inputs-hours"
                [class.error-input]="isTimeInvalid()">
                <div class="input-hour">
                    <input placeholder="HH" type="number" min=0 max=23 (ngModelChange)="changeHourInit($event)"
                        [ngModel]="hourInit == null ? '' : hourInit" [ngModelOptions]="{standalone: true}" [readOnly]="notEditable"
                        oninput="if(this.value > 23) this.value = 23; if(this.value < 0) this.value = 0;" />
                </div>
                <span class="points">:</span>
                <div class="input-hour">
                    <input placeholder="MM" type="number" min=0 max=59 (ngModelChange)="changeMinuteInit($event)"
                        [ngModel]="minuteInit == null ? '' : minuteInit" [ngModelOptions]="{standalone: true}" [readOnly]="notEditable"
                        oninput="if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 0;" />
                </div>
            </div>
        </div>
        <div class="calendar-option" *ngIf="typeDatepicker == 'start' && !notEditable">
            <app-calendar-event-dates [selectedDate]="startDate" (saveDate)="getDate($event)"
                [minDate]="dateOld"></app-calendar-event-dates>
        </div>
    </div>
</div>